import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useStaticQuery, graphql } from 'gatsby';
import * as url from 'url';
import { useAlternateUrl } from './useAlternateUrl';

const QUERY = graphql`
  {
    site {
      siteMetadata {
        title
        description
        keywords
        author
        baseUrl: siteUrl
        twitterUsername
        image
        imageType
        imageWidth
        imageHeight
      }
    }
  }
`;

export const useSeo = ({
  description: rDescription,
  title: rTitle,
  keywords: rKeyords,
  pageTitle: rPageTitle,
  pathname,
}) => {
  const { t } = useTranslation();
  const data = useStaticQuery(QUERY);
  const defaults = data.site.siteMetadata;
  const {
    imageType,
    imageWidth,
    imageHeight,
    twitterUsername,
    baseUrl: dBaseUrl,
    title: dTtitle,
    description: dDescription,
    keywords: dKeywords,
    image: dImage,
  } = defaults;

  const [baseUrl, setBaseUrl] = useState(dBaseUrl);
  const alternate = useAlternateUrl(baseUrl);
  const title = t([rTitle, dTtitle]);
  const description = t([rDescription, dDescription]);
  const keywords = t([rKeyords, dKeywords]);
  const canonical = baseUrl + pathname;
  const image = dImage ? url.parse(`${dBaseUrl}${dImage}`).href : false;
  const pageTitle = t([rPageTitle, dTtitle]);

  useEffect(() => {
    if (dBaseUrl === '') {
      setBaseUrl(window.location.origin);
    }
  }, [dBaseUrl]);

  const values = useMemo(
    () => ({
      title,
      description,
      keywords,
      canonical,
      image,
      baseUrl,
      alternate,
      imageType,
      imageWidth,
      imageHeight,
      twitterUsername,
      pageTitle,
    }),
    [
      alternate,
      baseUrl,
      canonical,
      description,
      image,
      imageHeight,
      imageType,
      imageWidth,
      keywords,
      title,
      twitterUsername,
      pageTitle,
    ],
  );

  return values;
};

export default useSeo;
